// An injected error handler's frame names a function such as `i.onerror` in
// Chromium or `bp/i.onerror` in Firefox. Everything ahead of the property name
// is a minified scope that shifts between extension builds, so the tail is the
// only part worth matching.
const INJECTED_ERROR_HANDLER_PATTERN = /\.onerror$/


// These events come from a browser extension's own error handler throwing inside
// itself. The extension's script is injected with no URL, so its one frame can't
// be attributed by origin: Chromium leaves the filename as `<anonymous>`, and
// Firefox fills in the document path instead. The message is generic enough that
// our own minified code could raise the same words, so matching on that isn't
// safe either. What identifies the error is its shape: it has a single
// unattributable frame whose function is an `onerror` property, and it reaches
// us through `window.onerror`, which Sentry only ever reports unhandled. Nothing
// of ours arrives that way. Every frame from our bundles carries a URL, and no
// inline script of ours registers an `.onerror` handler.
//
export default function isInjectedErrorHandlerError(values) {
  return values.some(({ mechanism, stacktrace }) => {
    const frames = stacktrace?.frames || []
    const [ frame ] = frames

    return mechanism?.type === 'onerror'
      && frames.length === 1
      && !frame.filename?.includes('://')
      && INJECTED_ERROR_HANDLER_PATTERN.test(frame.function || '')
  })
}
